import { StripeConnectAccount } from '../models';
import { ModelResource } from './resource';

export class StripeConnectAccounts extends ModelResource<StripeConnectAccount> {
  model = StripeConnectAccount;

  async fetchClientSecret() {
    return (await this.api.post('/v1/payment-accounts/stripe/session')).data.client_secret;
  }

  resourcePath = 'v1/payment-accounts/stripe';
}
